export const EvidenceIcon = (props) => (
  <svg fill="none" height={24} viewBox="0 0 24 24" width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M20.5 21L14.5 15M2.5 10C2.5 10.9193 2.68106 11.8295 3.03284 12.6788C3.38463 13.5281 3.90024 14.2997 4.55025 14.9497C5.20026 15.5998 5.97194 16.1154 6.82122 16.4672C7.6705 16.8189 8.58075 17 9.5 17C10.4193 17 11.3295 16.8189 12.1788 16.4672C13.0281 16.1154 13.7997 15.5998 14.4497 14.9497C15.0998 14.2997 15.6154 13.5281 15.9672 12.6788C16.3189 11.8295 16.5 10.9193 16.5 10C16.5 9.08075 16.3189 8.1705 15.9672 7.32122C15.6154 6.47194 15.0998 5.70026 14.4497 5.05025C13.7997 4.40024 13.0281 3.88463 12.1788 3.53284C11.3295 3.18106 10.4193 3 9.5 3C8.58075 3 7.6705 3.18106 6.82122 3.53284C5.97194 3.88463 5.20026 4.40024 4.55025 5.05025C3.90024 5.70026 3.38463 6.47194 3.03284 7.32122C2.68106 8.1705 2.5 9.08075 2.5 10Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.35}
    />
  </svg>
);
